var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-modal"},[_c('button',{staticClass:"question-button",style:({backgroundColor: _vm.theme.primaryColor}),on:{"click":_vm.showModal}},[_vm._v(" "+_vm._s(_vm.$t('showModal'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }